import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "color", "lineHeight"];
import styled from 'styled-components';
import { LayoutBox } from '../Layout/LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
const Text = styled(LayoutBox).withConfig({
  displayName: "BodySmall__Text",
  componentId: "sc-1tnsddl-0"
})(["line-height:", ";", ";"], ({
  $lineHeight
}) => $lineHeight, ({
  theme
}) => `
    font-size: ${theme.typography['detail-100'].fontSize};
    font-weight: ${theme.typography['detail-100'].fontWeight};
  `);
export const BodySmall = _ref => {
  let {
      as = 'p',
      children,
      color = 'base',
      lineHeight = 1.5
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Text, Object.assign({}, rest, {
    $lineHeight: lineHeight,
    color: color,
    forwardedAs: as,
    children: children
  }));
};